import React from 'react'
import { Link } from 'react-router-dom'
function Footer() {
  return (
    <>
      <div className='footer-container'>
        <div className='row gx-0' style={{ rowGap: "20px" }}>
          <div className='col-lg-4 col-md-12'>
            <div className='footerleftdiv'>
              <div className='headerborder'>
                <div>
                  <img src="img/mplogo.png" alt="Logo" className="footerimg" />
                </div>
                <div className='header-title-footer'>
                  <h6 className="mb-0">Directorate, Urban Administration &</h6>
                  <h6 className="mb-0"> Development Government of</h6>
                  <h6 className="mb-0">Madhya Pradesh</h6>
                </div>
              </div>
              {/* <img src="img/MP-orange.png" alt='mp map' className='mpmap-img' /> */}
                <img src="img/mp-map-green.svg" alt='mp map' className='mpmap-img' />
            </div>
          </div>
          <div className='col-lg-8 col-md-12'>
            <div className='row gx-0' style={{ rowGap: "20px" }}>
              <div className='col-md-4 col-sm-6 col-12 d-lg-flex justify-content-center'>
                <div className='footersection'>
                  <h6>Quick Links</h6>
                  <div>
                    <Link to="" className='footer-link'>Home</Link>
                  </div>
                  <div className='mt-3'>
                    <Link to="" className='footer-link'>About us</Link>
                  </div>
                  <div className='mt-3'>
                    <Link to="" className='footer-link'>Projects</Link>
                  </div>
                  <div className='mt-3'>
                    <Link to="" className='footer-link'>Features</Link>
                  </div>
                  <div className='mt-3'>
                    <Link to="" className='footer-link'>Contact us</Link>
                  </div>
                </div>
              </div>
              <div className='col-md-4 col-sm-6 col-12 d-lg-flex justify-content-center'>
                <div className='footersection'>
                  <h6>Projects</h6>
                  <h5 className='mt-3'>GIS based AMRUT plan</h5>
                  <h5 className='mt-3'>PM Gati Shakti</h5>
                  <h5 className='mt-3'>SBM (Swatch Bharat Mission)</h5>
                  <h5 className='mt-3'>One city one map</h5>
                  <h5 className='mt-3'>Smart city</h5>
                  <h5 className='mt-3'>E-Nagar Palika</h5>
                  <h5 className='mt-3'>ABPAS</h5>
                  <h5 className='mt-3'>SAMPADA</h5>
                </div>
              </div>
              <div className='col-md-4 col-sm-6 col-12 d-lg-flex justify-content-center'>
                <div className='footersection'>
                  <h6>Contact</h6>
                  <h5 className='mt-2'>+91-7552575491</h5>
                  <h5 className='mt-3'>citizenhelpdesk@mpurban.gov.in</h5>
                  <h5 className='mt-3'>Office of commissioner, Third Floor, Palika Bhawan, Shivaji Nagar, Bhopal, Pin - 462016</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer